import React, { useMemo } from 'react';
import { ProField } from '@bedrock/pro-field';
import { ProCurrency } from '@bedrock/eed-react';
import { useChangeRate } from '../../hooks/useChangeRate';
import Decimal from 'decimal.js';
import { currencyEnum } from '#utils/number';
import { isBlank } from '@bedrock/utils';

export interface MPCProCurrencyProps
  extends React.ComponentProps<typeof ProCurrency> {
  viewCurrency?: string;
  fieldProps: {
    value: {
      currency: string;
      amount: number;
    };
    style?: React.CSSProperties;
    showCurrency?: boolean;
    highlight?: boolean;
    currencyBeforeAmount?: boolean;
    format?: (value: string) => string;
    color?: string;
    showUnitIndicator?: boolean;
    precision?: number;
  };
  className?: string;
  readonly?: boolean;
}

const MPCProCurrency = (props: MPCProCurrencyProps) => {
  const { viewCurrency, fieldProps, readonly = true, ...rest } = props;
  const { changeRateList } = useChangeRate();
  
  const value = useMemo(() => {
    let amount = fieldProps.value.amount;
    const currency = fieldProps.value.currency;
    let currencyText = currencyEnum[currency?.toLocaleLowerCase?.()];

    if (viewCurrency && currency && currency !== viewCurrency) {
      const exchangeRate = changeRateList.find(
        (item) =>
          item.from_currency?.toLowerCase() === currency.toLowerCase() &&
          item.to_currency?.toLowerCase() === viewCurrency.toLowerCase()
      )?.exchange_rate;

      if (exchangeRate) {
        amount = isBlank(amount) ? amount : new Decimal(amount).mul(exchangeRate).toNumber();
        currencyText = currencyEnum[viewCurrency?.toLocaleLowerCase?.()];
      }
    }

    return {
      currency: currencyText,
      amount,
    };
  }, [fieldProps.value, viewCurrency]);

  return (
    <ProField
      {...rest}
      readonly={readonly}
      fieldProps={{
        ...fieldProps,
        value,
      }}
      valueType={'currency'}
    />
  );
};

export default MPCProCurrency;
